import { render, staticRenderFns } from "./CustomerDocuments.vue?vue&type=template&id=e6a1d710&scoped=true"
import script from "./CustomerDocuments.vue?vue&type=script&lang=js"
export * from "./CustomerDocuments.vue?vue&type=script&lang=js"
import style0 from "./CustomerDocuments.vue?vue&type=style&index=0&id=e6a1d710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a1d710",
  null
  
)

export default component.exports